import { useState } from 'react';
import BloomreachHtml from '@mediashop/app/components/BloomreachHtml';
import classNames from 'classnames';
import BloomreachImageResponsive from '../../../atom/BloomreachImageResponsive';
import Modal from '../../Modal';
import { USPsItemProps } from './index';
import { BrXImageVariant } from '../../../../types/imageVariants';
import { LinkOpenInTab } from '../../../atom/LinkOpenInTab';
import { EMPTY_STRING } from '@mediashop/app/constants/semanticConstants';
import TextCompound from '../../../atom/TextCompound';

const USPsItem = ({ className, usp, fontColorHex }: USPsItemProps): JSX.Element => {
    const [openModal, setOpenModal] = useState<boolean>(false);
    const infoText = typeof usp.infoTextHTML === 'object' && usp.infoTextHTML?.value ? usp.infoTextHTML : usp.infoText;

    return (
        <LinkOpenInTab
            tab={usp.linkOpenInTabWoText?.tab}
            link={!infoText ? usp.linkOpenInTabWoText?.link : EMPTY_STRING}
            className={`${className}__item`}
        >
            <div
                className={classNames(`${className}__item`, {
                    [`${className}__icon-wrapper--clickable`]: infoText,
                })}
                onClick={infoText ? () => setOpenModal(true) : undefined}
            >
                <div role="button" className={`${className}__icon-wrapper`} title={usp.text}>
                    <BloomreachImageResponsive
                        className={`${className}__icon`}
                        alt={usp.altText}
                        desktopImage={usp.icon}
                        variant={BrXImageVariant.USPs}
                    />
                </div>
                <div
                    className={`${className}__text-container`}
                    style={usp.maxWidth?.length > 0 ? { maxWidth: usp.maxWidth } : { maxWidth: '125px' }}
                >
                    <TextCompound
                        desktop={usp.desktopMobileText?.desktop}
                        mobile={usp.desktopMobileText?.mobile}
                        className={`${className}__text`}
                        style={fontColorHex ? { color: fontColorHex } : {}}
                    />
                </div>
            </div>
            <Modal
                isOpen={openModal}
                onRequestClose={() => setOpenModal(false)}
                overlayClassName={`${className}__modal-background`}
            >
                <BloomreachHtml html={infoText} />
            </Modal>
        </LinkOpenInTab>
    );
};

export default USPsItem;
